import { InvestingPersonEnum, RetirementAccountEnum } from 'interfaces'
import { useMemo } from 'react'

export const useGTMData = (getValues: any): any => {
  const state = getValues()
  const sharePrice = Number(process.env.REACT_APP_SHARE_PRICE)

  return useMemo(() => {
    const user_info = {
      email: state.email,
      first_name: state.basicInfo?.firstName,
      last_name: state.basicInfo?.lastName,
      middle_name: state.basicInfo?.middleName,
      suffix: state.basicInfo?.suffix,
      phone_number: state.personalInfo?.phoneNumber,
      birthday: state.personalInfo?.birthday,
      ip_address: state.ipAddress,
    }

    const customer_address = {
      country: 'United States of America',
      state: state.addressInfo?.state,
      street_1: state.addressInfo?.Street1,
      street_2: state.addressInfo?.Street2,
      city: state.addressInfo?.city,
      postal_code: state.addressInfo?.postalCode,
    }

    const secondary_user_info = state.secondary
      ? {
          email: state.secondary.email,
          first_name: state.secondary.basicInfo?.firstName,
          last_name: state.secondary.basicInfo?.lastName,
          middle_name: state.secondary.basicInfo?.middleName,
          suffix: state.secondary.basicInfo?.suffix,
          phone_number: state.secondary.personalInfo?.phoneNumber,
          birthday: state.secondary.personalInfo?.birthday,
          ip_address: state.ipAddress,
        }
      : undefined

    const ecommerce = {
      currency: 'USD',
      value: state.investingProfile?.amount,
      coupon: '',
      shipping_tier: '',
      payment_type: state.investingProfile?.paymentMethod,
      transaction_id: state.investingProfile?.tradeId,
      items: [
        {
          item_id: '',
          item_name: 'AFBC Investment',
          coupon: '',
          discount: '',
          index: state.investingProfile?.tradeId,
          item_brand: 'AFBC',
          item_category: 'Regulation A',
          item_variant: '',
          price: sharePrice,
          quantity: state.investingProfile?.totalShares,
        },
      ],
    }

    let entity_details = {}

    switch (state.investingProfile?.option) {
      case InvestingPersonEnum.FOR_MYSELF:
        return {
          user_info,
          customer_address,
          ecommerce,
        }
      case InvestingPersonEnum.JOINTLY:
        return {
          user_info,
          secondary_user_info,
          customer_address,
          ecommerce,
        }

      case InvestingPersonEnum.IN_BEHALF_OF_AN_ENTITY:
        entity_details = {
          email: state.entityDetails?.email,
          company_name: state.entityDetails?.companyName,
          phone_number: state.entityDetails?.phoneNumber,
          state: state.entityDetails?.addressInfo?.state,
          street_1: state.entityDetails?.addressInfo?.Street1,
          street_2: state.entityDetails?.addressInfo?.Street2,
          city: state.entityDetails?.addressInfo?.city,
          postal_code: state.entityDetails?.addressInfo?.postalCode,
        }
        return {
          user_info,
          customer_address,
          entity_details,
          ecommerce,
        }

      case InvestingPersonEnum.RETIREMENT:
        if (state.investingProfile.retirementAccountType === RetirementAccountEnum.RETIREMENT_ACCOUNT) {
          entity_details = {
            custodian_name: state.entityDetails?.nameOfCustodian,
            email: state.entityDetails?.emailOfIraContact,
            retirement_account_name: state.entityDetails?.name,
            phone_number: state.entityDetails?.phoneNumber,
            state: state.entityDetails?.addressInfo?.state,
            street_1: state.entityDetails?.addressInfo?.Street1,
            street_2: state.entityDetails?.addressInfo?.Street2,
            city: state.entityDetails?.addressInfo?.city,
            postal_code: state.entityDetails?.addressInfo?.postalCode,
          }
        } else if (state.investingProfile.retirementAccountType === RetirementAccountEnum.TRUST_ACCOUNT) {
          entity_details = {
            email: state.entityDetails?.email,
            trust_account_name: state.entityDetails?.name,
            phone_number: state.entityDetails?.phoneNumber,
            state: state.entityDetails?.addressInfo?.state,
            street_1: state.entityDetails?.addressInfo?.Street1,
            street_2: state.entityDetails?.addressInfo?.Street2,
            city: state.entityDetails?.addressInfo?.city,
            postal_code: state.entityDetails?.addressInfo?.postalCode,
          }
        }
        return {
          user_info,
          customer_address,
          entity_details,
          ecommerce,
        }

      default:
        return {
          user_info,
          customer_address,
          ecommerce,
        }
    }
  }, [state])
}
